import { jsx } from 'react/jsx-runtime';
import { Component } from 'react';
import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { Checkbox } from '../../Checkbox/index.js';

const MarginCheckbox = styled(Checkbox)`
  padding: ${ndsTokens.space.generic.x1} 0;
`; // TODO: fix eslint rule react/no-unsafe https://git.target.com/design-systems/nicollet/issues/1315

/* eslint-disable react/no-unsafe */

class OptionItemCheckbox extends Component {
  constructor(props) {
    super(props);
    const {
      selected = false
    } = props.data;
    this.state = {
      selected
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleMultiSelect = this.handleMultiSelect.bind(this);
  }
  /**
   * On subsequent updates after first mount
   * Options will not update unless updated in state.
   */

  /* eslint-disable-next-line camelcase */


  UNSAFE_componentWillReceiveProps(nextProps) {
    let {
      selected
    } = nextProps.data;

    if (!selected) {
      selected = false;
    }

    this.setState({
      selected
    });
  }
  /**
   * lets the event bubble up.
   * Does not allow un-select already selected values,
   * only triggers on change of select, like the
   * native select box does.
   * @param {Object} event DOM click event
   */


  handleSelect(event) {
    const targetType = event.target.type;

    if (targetType !== 'checkbox') {
      event.preventDefault();
    }

    const {
      onChange,
      data
    } = this.props;
    let {
      selected
    } = this.state;

    if (!selected) {
      selected = !selected;
    }

    this.setState({
      selected
    });
    onChange(event, data);
  }
  /**
   * lets the event bubble up.
   * Does allow un-select already selected values.
   * Triggers OnChange when a value is selected or unselected
   * @param {Object} event DOM click event
   */


  handleMultiSelect(event) {
    const targetType = event.target.type;

    if (targetType !== 'checkbox') {
      event.preventDefault();
    }

    const {
      label = '',
      value
    } = this.props.data;
    const {
      onChange
    } = this.props;
    const selected = !this.state.selected;
    this.setState(prevState => ({
      selected: !prevState.selected
    }));
    onChange(event, {
      label,
      value,
      selected
    });
  }

  render() {
    const {
      selected
    } = this.state;
    const {
      multiSelect,
      name,
      childRef,
      data
    } = this.props;
    const {
      label,
      value
    } = data !== null && data !== void 0 ? data : {};
    return jsx(MarginCheckbox, {
      checked: !!selected,
      className: "h-margin-v-tight",
      id: name,
      label: label,
      name: name,
      onChange: multiSelect ? this.handleMultiSelect : this.handleSelect,
      ref: childRef,
      value: value
    }, void 0);
  }

}
OptionItemCheckbox.displayName = 'OptionItemCheckbox';

export { OptionItemCheckbox };
